module.exports = __webpack_public_path__ + "img/carrousel-captores-4.8bd0be86.jpg";